<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <ClientNav/>
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
              :headers="headers"
              :items="monthlySummaries"
              sort-by="StartDate"
              sort-desc
              :loading="isLoading"
              loading-text="Loading Monthly Summaries"
              :search="search"
              height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Quarterly Summaries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="100%">
                  <template v-slot:activator="{ on }">
                    <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                    >
                      <v-icon left>add</v-icon>
                      Add Summary</v-btn
                    >
                  </template>
                  <template v-slot:item.editActions="{ item }">
                    <v-icon small class="mr-2" @click="viewWeeklySummary(item)">
                      mdi-eye
                    </v-icon>

                    <v-icon small @click="deleteWeeklySummary(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm  }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="6">
                            <v-col cols="12" sm="12" md="6">
                              <v-select :items="years" v-model="selectedYear" label="Year">
                                <option value="">----</option>
                                <option :value="year" v-for="year in years" :key="year">
                                  {{ year }}
                                </option>
                              </v-select>
                            </v-col>
                            <v-col cols="6" sm="12" md="6">
                              <v-select :items="quarter" v-model="selectedQuarter" label="Choose Quarter"
                              ></v-select>
                            </v-col>
                            <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                              <v-btn x-small @click="getStartAndEndDate()">Search</v-btn>
                            </v-flex>

                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-text-field
                                :value="newPlanDate"
                                label="Current Date"
                                v-on="on"
                                prepend-icon="events"
                                v-model="newCurrentDate"
                                readonly
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <!-- <v-menu
                              offset-y
                              min-width="290px"
                              max-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="newPlanDate"
                                  label="Plan Date"
                                  v-on="on"
                                  prepend-icon="events"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="newPlanDate" scrollable></v-date-picker>
                            </v-menu> -->
                            <v-menu
                                ref="menu3"
                                v-model="menu3"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="newPlanDate"
                                    label="Plan Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  v-model="newPlanDate"
                                  no-title
                                  scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu3 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu3.save(date)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-select
                                label="Service Codes"
                                :items="codes"
                                item-text="Name"
                                item-value="Name"
                                v-model="newCode"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" >
                            <v-textarea
                                label="Goal"
                                outlined
                                v-model="newGoal"
                            ></v-textarea>
                          </v-col>

                          <v-col cols="12" sm="12" >
                            <v-textarea
                                label="Purpose"
                                outlined
                                v-model="newPurpose"
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12" sm="12">
                            <v-textarea
                                label="Details of the Support"
                                outlined
                                v-model="newDetails"
                            ></v-textarea>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                          >
                            <v-text-field v-model="summaryTitle"
                                          label="Summary Title"
                                          placeholder=""
                                          outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12">
                            <!--                      <template>-->
                            <!--                        <v-simple-table>-->
                            <!--                          <template v-slot:default>-->
                            <!--                            <thead>-->
                            <!--                            <tr>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Report Date-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Summary-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Manager Signature-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Supervisor Signature-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                ClientServSig-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Submitted-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Providers-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                Guardian-->
                            <!--                              </th>-->
                            <!--                              <th class="text-left">-->
                            <!--                                ClientID-->
                            <!--                              </th>-->
                            <!--                            </tr>-->
                            <!--                            </thead>-->
                            <!--                            <tbody>-->
                            <!--                            <tr>-->
                            <!--                              <td></td>-->
                            <!--                              <td>kjfk</td>-->
                            <!--                            </tr>-->
                            <!--                            </tbody>-->
                            <!--                          </template>-->
                            <!--                        </v-simple-table>-->
                            <!--                      </template>-->
                            <template>
                              <v-data-table v-model="newSummary"
                                            :headers="addMonthlySummaryHeaders" :items="allWeeklySummaries"
                                            hide-default-footer
                                            disable-pagination
                                            class="elevation-1"

                              ></v-data-table>
                            </template>
                            <!--                          <v-data-table v-model="newSummary"-->
                            <!--                              :headers="addMonthlySummaryHeaders"-->
                            <!--                              :items="allWeeklySummaries"-->
                            <!--                              :hide-default-header="true"-->
                            <!--                              :hide-default-footer="true"-->
                            <!--                              class="elevation-1"-->
                            <!--                          >-->
                            <!--                          </v-data-table>-->
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-checkbox
                                v-model="signedManager"
                                label="Manager Signature"
                                outlined
                                @click="addManagerSig()"
                            ></v-checkbox>
                            <v-text-field label="Signed By" v-model="newManagerSignature" ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6"></v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-checkbox
                                v-model="signedSupervisor"
                                label="Supervisor Signature"
                                outlined
                                @click="addSupervisorSig()"
                            ></v-checkbox>
                            <v-text-field label="Signed By" v-model="newSupervisorSignature" ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6"></v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-checkbox
                                v-model="signedClient"
                                label="Client Services Signature"
                                outlined
                                @click="addClientSig()"
                            ></v-checkbox>
                            <v-text-field label="Signed By" v-model="newClientServSig" ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6"></v-col>
                          <v-col cols="6" sm="6" md="6">
                            <!-- <v-menu
                              offset-y
                              min-width="290px"
                              max-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="newSubmitted"
                                  label="Submitted"
                                  v-on="on"
                                  prepend-icon="events"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="newSubmitted" scrollable></v-date-picker>
                            </v-menu> -->
                            <v-menu
                                ref="menu4"
                                v-model="menu4"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="newSubmitted"
                                    label="Submitted"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  v-model="newSubmitted"
                                  no-title
                                  scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu4 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu4.save(date)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col>
                            <v-select
                                label="Providers"
                                :items="providers"
                                item-text="Name"
                                item-value="Name"
                                v-model="newProviders"
                            >
                            </v-select>
                          </v-col>
                          <v-col>
                            <v-select
                                multiple
                                label="Email Contact"
                                v-model="newGuardian"
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" color="#259647" @click="addMonthlySummary()" v-if="newSummaryBool">Save</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="updateMonthlySummary()" v-if="editSummary">Update</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewMonthlySummary(item)">
                mdi-eye
              </v-icon>

              <v-icon small @click="deleteMonthlySummary(item)">
                mdi-delete
              </v-icon>

            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getMonthlySummaries()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import moment from 'moment'


const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Start Date',
          align: 'start',
          value: 'StartDate',
        },
        { text: "End Date", value: "EndDate" },
        { text: "Summary", value: "SummaryTitle" },
        { text: "Submitted", value: "Submitted" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      addMonthlySummaryHeaders: [
        {
          text: 'Report Date',
          align: 'start',
          value: 'ReportDate',
        },
        { text: "Summary", value: "Summary" },
        { text: "Manager Signature", value: "ManagerSignature" },
        { text: "Supervisor Signature", value: "SupervisorSignature" },
        { text: "ClientServSig", value: "ClientServSig" },
        { text: "Submitted", value: "Submitted" },
        { text: "Providers", value: "Providers" },
        { text: "Guardian", value: "Guardian" },
        { text: "ClientID", value: "ClientID" },
      ],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      dialog: false,
      editSummary: false,
      newSummaryBool: false,
      msg: false,
      signedManager: false,
      signedSupervisor: false,
      signedClient: false,
      search: "",
      text:"",
      monthlySummaries: [],
      allWeeklySummaries: [],
      weeklyIdsSummaries:[],
      years:[],
      units: [],
      codes: [],
      tempData: [],
      users: [],
      goals: [],
      staff: "",
      unitID: localStorage.getItem('unitID'),
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem('userID'),
      titleForm: "New Weekly Summary",
      summaryID: "",
      newStartDate: "",
      newEndDate: "",
      selectedYear: "",
      selectedQuarter:"",
      quarter:['First Quarter', 'Second Quarter', 'Third Quarter', 'Fourth Quarter'],
      monthsSelected:[],
      newCurrentDate: new Date(),
      newPlanDate: "",
      newCode: "",
      newGoal: "",
      newPurpose: "",
      newDetails: "",
      summaryTitle: "",
      newSummary: "",
      newManagerSignature: "",
      newSupervisorSignature: "",
      newClientServSig: "",
      newSubmitted: "",
      newProviders: "",
      newGuardian: "",
      editedIndex: -1,
      editedItem: {
        startDate: "",
        endDate: "",
        currentDate: "",
        planDate: "",
        code: "",
        goal: "",
        purpose: "",
        details: "",
        summary: "",
        managerSignature: "",
        supervisorSignature: "",
        clientServSig: "",
        submitted: "",
        providers: "",
        guardian: "",
      },
      defaultItem: {
        startDate: "",
        endDate: "",
        currentDate: "",
        planDate: "",
        code: "",
        goal: "",
        purpose: "",
        details: "",
        summary: "",
        managerSignature: "",
        supervisorSignature: "",
        clientServSig: "",
        submitted: "",
        providers: "",
        guardian: "",
      },
      isLoading: true,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getMonthlySummaries();
    this.getUsers();
    this.getServiceCodesFromCode();
    this.getListOfProviders();
    this.getYears();
  },

  methods: {
    initialize() {
      this.monthlySummaries = [];
    },
    viewMonthlySummary(item) {
      this.titleForm= "Viewing Monthly Summary";
      this.dialog = true;
      this.editSummary = true;
      this.newSummaryBool = false;
      this.newStartDate = item.StartDate;
      this.newEndDate = item.EndDate;
      this.newCurrentDate = item.CurrentDate;
      this.newPlanDate = item.PlanDate;
      this.newCode = item.Code;
      this.newGoal = item.Goal;
      this.newPurpose = item.Purpose;
      this.newDetails = item.Details;
      this.summaryTitle = item.summaryTitle;
      this.newSummary = item.newSummary;
      this.newManagerSignature = item.ManagerSignature;
      this.newSupervisorSignature = item.SupervisorSignature;
      this.newClientServSig = item.ClientServSig;
      this.newSubmitted = item.Submitted;
      this.newProviders = item.Providers;
      this.newGuardian = item.Guardian;
      this.summaryID = item._id;
      this.getAllWeeklyReportWithinDateRange(item.newStartDate,item.newEndDate);
    },
    showAdd() {
      this.titleForm= "New Quarterly Summary";
      this.newSummaryBool = true;
      this.editSummary = false;
    },

    deleteMonthlySummary(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this quarterly summary?") &&
      this.monthlySummaryDelete(id);

    },

    monthlySummaryDelete(id) {
      axios.delete(`${url}/monthlySummary/${id}`)
          .then((response) => {
            this.getMonthlySummaries();
            if (response.status == 400) {
              response.json().then(function(data) {
                return data.msg;
              });
            }
            this.msg=true;
            this.text="The quarterly summary has been deleted successfully.";
          });
    },

    close() {
      this.clear()
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateMonthlySummary() {
      var req_body = {
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        CurrentDate: this.newCurrentDate,
        PlanDate: this.newPlanDate,
        Code: this.newCode,
        Goal: this.newGoal,
        Purpose: this.newPurpose,
        Details: this.newDetails,
        SummaryTitle: this.summaryTitle,
        Summary: this.newSummary,
        MangerSignature: this.newManagerSignature,
        SupervisorSignature: this.newSupervisorSignature,
        ClientServSig: this.newClientServSig,
        Submitted: this.newSubmitted,
        Providers: this.newProviders,
        Guardian: this.newGuardian,
      };
      axios.put(`${url}/monthlySummary/${this.summaryID}`, req_body).then((response) => {
        this.getMonthlySummaries();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.msg=true;
        this.text="The quarterly summary has been updated successfully.";
      });
      this.close();
    },
    getMonthlySummaries: function() {
      this.isLoading = true;
      axios.get(`${url}/monthlySummary`).then(res => {
        this.monthlySummaries = [],
            this.tempData = res.data.summaries;
        for (var i=0; i < this.tempData.length; i++){
          if (this.tempData[i].ClientID == this.clientID) {
            this.monthlySummaries.push(this.tempData[i])
          }
        }
      }).finally(() => this.isLoading = false);
    },

    addMonthlySummary: function() {
      var req_body = {
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        CurrentDate: this.newCurrentDate,
        PlanDate: this.newPlanDate,
        Code: this.newCode,
        Goal: this.newGoal,
        Purpose: this.newPurpose,
        Details: this.newDetails,
        SummaryTitle: this.summaryTitle,
        Summary: this.weeklyIdsSummaries,
        ManagerSignature: this.newManagerSignature,
        SupervisorSignature: this.newSupervisorSignature,
        ClientServSig: this.newClientServSig,
        Submitted: this.newSubmitted,
        Providers: this.newProviders,
        Guardian: this.newGuardian,
        ClientID: this.clientID,
      };

      axios.post(`${url}/monthlySummary`, req_body ).then(res => {
        this.getMonthlySummaries();
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text=data.msg;
          });
        }
        this.msg=true;
        this.text="The new quarterly summary has been added successfully.";
      });
      this.close();
    },

    getUsers: function() {
      axios.get(`${url}/users`).then(async res => {
        this.users = res.data.users;
        for (var i=0; i < this.users.length; i++){
          if (this.userID == this.users[i]._id) {
            this.staff = this.users[i].Name
          }
        }
      });
    },

    addManagerSig: function() {
      if(!this.signedManager) return this.newManagerSignature = ''
      this.newManagerSignature = this.staff + " - " + new Date();
    },

    addSupervisorSig: function() {
      if(!this.signedSupervisor) return this.newSupervisorSignature = ''
      this.newSupervisorSignature = this.staff + " - " + new Date();
    },

    addClientSig: function() {
      if(!this.signedClient) return this.newClientServSig = ''
      this.newClientServSig = this.staff + " - " + new Date();
    },

    getServiceCodesFromCode() {
      axios.get(`${url}/codes/list`).then(async res => {
        this.codes = res.data;
      });
    },

    getListOfProviders() {
      axios.get(`${url}/codes/providerslist`).then(async res => {
        this.providers = res.data;
      });
    },
    getYears(){
      let years=[];
      for (let i = 2000; i <= new Date().getFullYear(); i++) {
        years.push(i);
      }
      this.years = years;
    },
    getStartAndEndDate(){
      var startDate = new Date();
      var endDate = new Date();
      if(this.selectedQuarter === 'First Quarter'){
        startDate.setMonth(0,1);
        startDate.setYear(this.selectedYear);
        this.newStartDate = startDate;
        this.startDateFormat(this.newStartDate);
        endDate.setMonth(2,1);
        endDate.setYear(this.selectedYear);
        this.newEndDate = endDate;
        this.endDateFormat(this.newEndDate);
      }else if(this.selectedQuarter === 'Second Quarter') {
        startDate.setMonth(3,1);
        startDate.setYear(this.selectedYear);
        this.newStartDate = startDate;
        this.startDateFormat(this.newStartDate);
        endDate.setMonth(5,1);
        endDate.setYear(this.selectedYear);
        this.newEndDate = endDate;
        this.endDateFormat(this.newEndDate);
      }else if(this.selectedQuarter === 'Third Quarter'){
        startDate.setMonth(6,1);
        startDate.setYear(this.selectedYear);
        this.newStartDate = startDate;
        this.startDateFormat(this.newStartDate);
        endDate.setMonth(8,1);
        endDate.setYear(this.selectedYear);
        this.newEndDate = endDate;
        this.endDateFormat(this.newEndDate);
      }else if(this.selectedQuarter === 'Fourth Quarter'){
        startDate.setMonth(9,1);
        startDate.setYear(this.selectedYear);
        this.newStartDate = startDate;
        this.startDateFormat(this.newStartDate);
        endDate.setMonth(11,1);
        endDate.setYear(this.selectedYear);
        this.newEndDate = endDate;
        this.endDateFormat(this.newEndDate);
      }
      axios.get(`${url}/weeklySummary/${this.newStartDate}/${this.newEndDate}/${this.clientID}`).then(res => {
        this.allWeeklySummaries = res.data.summaries
        console.log(this.allWeeklySummaries);
        for(let counterForWeeklySummaries=0; counterForWeeklySummaries < this.allWeeklySummaries.length; counterForWeeklySummaries++){
          this.weeklyIdsSummaries.push(this.allWeeklySummaries[counterForWeeklySummaries]._id)
        }
      })
    },
    startDateFormat: function(date) {
      this.newStartDate= moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    endDateFormat: function(date) {
      this.newEndDate= moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },


    clear(){
      this.newStartDate = "";
      this.newEndDate = "";
      this.newCurrentDate = "";
      this.newPlanDate = "";
      this.newCode = "";
      this.newGoal = "";
      this.newPurpose = "";
      this.newDetails = "";
      this.newSummary = "";
      this.newManagerSignature = "";
      this.newSupervisorSignature = "";
      this.newClientServSig = "";
      this.newSubmitted = "";
      this.newProviders = "";
      this.newGuardian = "";
      this.signedManager = false;
      this.signedSupervisor = false;
      this.signedClient = false;
    }

  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}
</style>